import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { crearUsuariosAcademia } from "../../../../shared/fetchers/academia/crearUsuario";
import { DropzoneArea } from "material-ui-dropzone";
import { Button } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import { CheckRounded } from "@material-ui/icons";
import CustomGreenButton from "../../../../components/shared/custom-green-button";
import { Link } from "react-router-dom";
import swal from "sweetalert";

const CrearUsuarioAcademiaMasivo = () => {
  const [users, setUsers] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDropFileChange = (file) => {
    setUsers(file);
  };

  const addUsers = async () => {
    setLoading(true);

    const res = await crearUsuariosAcademia(users[0]);

    if (!res.status) {
      await swal({
        title: "Error",
        text: res.info,
        icon: "error",
      });
    } else {
      await swal({
        title: "Éxito",
        text: res.info,
        icon: "success",
      });
    }

    setLoading(false);
  };

  return (
    <Col xs={12} className="content-white-box px-4 py-4 mt-3">
      <div className="d-flex align-items-center">
        <PersonIcon style={{ fontSize: "17px" }} />
        <div className="admin-main-title-dark-gray ml-2 mt-1">
          Agregar Usuarios Academia (carga masiva)
        </div>
      </div>
      <div className="my-3">
        <Link
          to="/templates/formacion/crear-usuario.xlsx"
          target="_blank"
          download
        >
          <CustomGreenButton size="small" variant="contained">
            Descargar plantilla
          </CustomGreenButton>
        </Link>
      </div>
      <form>
        <DropzoneArea
          id="dropzone"
          dropzoneText="Arrastra un archivo o haz click aquí!"
          showFileNames={true}
          showAlerts={true}
          disabled={loading}
          filesLimit={1}
          acceptedFiles={[
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
          ]}
          onChange={(files) => handleDropFileChange(files)}
        />

        <div className="mt-3">
          <Button
            variant="contained"
            color="primary"
            disabled={!users.length || loading}
            startIcon={<CheckRounded style={{ fontSize: "25px" }} />}
            onClick={addUsers}
            style={{ background: "#81c868" }}
          >
            Agregar
          </Button>
        </div>
      </form>
    </Col>
  );
};

export default CrearUsuarioAcademiaMasivo;
